import { useNavigate } from 'react-router-dom';
import { CartButton } from '@/components/common/CartButton';
import { NotificationButton } from '@/components/common/NotificationButton';
import { useLocationStore } from '@/store/location';

interface HomeHeaderProps {
  onAddressClick: () => void;
}

export function HomeHeader({ onAddressClick }: HomeHeaderProps) {
  const navigate = useNavigate();
  const { currentLocation } = useLocationStore();

  return (
    <header style={{ marginBottom: '16px' }}>
      <div className="flex items-center gap-3">
        <button 
          className="flex items-center gap-2 bg-transparent border-none p-0 cursor-pointer hover:opacity-70 transition-opacity overflow-hidden"
          style={{ flex: '1 1 auto', minWidth: 0 }}
          onClick={onAddressClick}
        >
          <img 
            src="/icons/icon_map_pin.svg" 
            alt="위치" 
            className="w-6 h-6 flex-shrink-0"
          />
          <div className="overflow-hidden">
            <span className="inline-block text-[14px] min-[376px]:text-[16px] font-medium text-[#222222] border-b border-[#333333] pb-1 max-w-full overflow-hidden text-ellipsis whitespace-nowrap">
              {currentLocation.address?.roadAddress || '위치를 설정해주세요'}
            </span>
          </div>
        </button>
        
        <div className="flex items-center flex-shrink-0" style={{ gap: '16px' }}>
          <button 
            className="p-0 bg-transparent border-none cursor-pointer active:opacity-70 transition-opacity"
            onClick={() => navigate('/buyer/search')}
          >
            <img 
              src="/icons/common_home_search_button.svg" 
              alt="검색" 
              className="w-6 h-6"
            />
          </button>
          <CartButton size="medium" className="bg-transparent border-none" />
          <NotificationButton />
        </div>
      </div>
    </header>
  );
}
